import { DefaultInputPropTypes, SearchInput, FormFieldsData, SearchInputProps } from 'framework/form';
import { ResourceData } from 'framework/crud';
import { useProjectService } from 'domain/shared/project';

interface ProjectInputProps
  extends Omit<SearchInputProps, 'searchRequest' | 'labelHint'>, DefaultInputPropTypes<string> {
  source: string;
  label?: string;
  initialLabel?: string;
  searchString?: string;
  nameSource?: string;
  mapResults?: (project: any) => void;
  search?: (request: ResourceData) => any;
  isVisible?: boolean | ((data: FormFieldsData) => boolean);
  errorSource?: string;
  props?: any;
}

const ProjectInput = ({ mapResults, source, search, ...props }: ProjectInputProps) => {
  const { search: defaultSearch } = useProjectService();

  const mapResponse = (project: any) => ({
    id: project.id,
    text: project.name,
  });

  return (
    <SearchInput
      {...props}
      source={source}
      searchRequest={search ?? defaultSearch}
      noResultMessage="No Projects are found."
      mapResults={mapResults || mapResponse}
    />
  );
};

export default ProjectInput;
